(() => {
  const SELECTORS = {
    form: 'form[action^="/cart/add"]',
    productCard: '.product-card',
    variantInput: 'input[name="id"]',
    // Some themes add-to-cart from buttons with dataset
    atcButton: '[data-add-to-cart], [data-quick-add], button[name="add"], .product-card__atc',
  };

  const state = {
    cart: null,
    memberMode: false,
    membershipDetect: (cart) => {
      if (!cart || !Array.isArray(cart.items)) return false;
      // TODO: replace with your real membership line detection if needed.
      return cart.items.some((item) => {
        const title = (item.product_title || item.title || '').toLowerCase();
        return title.includes('membership');
      });
    },
  };

  function computeMemberMode() {
    const customerActive =
      (window.monthleesCustomer && window.monthleesCustomer.membership_status === 'active') ||
      (window.monthleesCustomer && window.monthleesCustomer.membership_status === 'trialing');

    const cartHasMembership = state.membershipDetect(state.cart);
    state.memberMode = Boolean(customerActive || cartHasMembership);
  }

  async function refreshCart() {
    try {
      const res = await fetch(`/cart.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!res.ok) return;
      state.cart = await res.json();
      computeMemberMode();
    } catch (e) {}
  }

  function getSwapVariantIdFromCard(productCardEl) {
    if (!productCardEl) return null;
    const memberId = productCardEl.dataset?.mlMemberVariantId;
    const retailId = productCardEl.dataset?.mlRetailVariantId;
    if (!memberId && !retailId) return null;
    return state.memberMode ? memberId : retailId;
  }

  // 1) Intercept FORM submits (/cart/add)
  function handleSubmitCapture(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches(SELECTORS.form)) return;

    const productCard = form.closest(SELECTORS.productCard);
    if (!productCard) return;

    const swapTo = getSwapVariantIdFromCard(productCard);
    if (!swapTo) return;

    const input = form.querySelector(SELECTORS.variantInput);
    if (!input) return;

    if (String(input.value) !== String(swapTo)) {
      input.value = String(swapTo);
    }
  }
  document.addEventListener('submit', handleSubmitCapture, true);

  // 2) Intercept FETCH to /cart/add(.js)
  // This catches themes that add-to-cart via JS without submitting a form.
  const _fetch = window.fetch.bind(window);
  window.fetch = async (input, init = {}) => {
    try {
      const url = typeof input === 'string' ? input : input?.url || '';
      const isAdd =
        typeof url === 'string' &&
        (url.includes('/cart/add') || url.includes('/cart/add.js') || url.includes('/cart/add.json'));

      if (isAdd && init && init.body) {
        // If body is FormData, we can swap "id"
        if (init.body instanceof FormData) {
          const fd = init.body;

          // Try to find context from an "active element" click
          const active = document.activeElement;
          const card =
            active?.closest?.(SELECTORS.productCard) ||
            (active?.getRootNode?.()?.activeElement?.closest?.(SELECTORS.productCard)) ||
            null;

          const swapTo = getSwapVariantIdFromCard(card);
          if (swapTo) {
            // Shopify uses "id" for variant id
            fd.set('id', String(swapTo));
          }

          init.body = fd;
        }

        // If body is JSON string, you *can* parse/replace too — but most themes use FormData.
      }
    } catch (e) {
      // If anything goes wrong, fall through to original fetch
    }

    return _fetch(input, init);
  };

  // Keep member-mode updated via FoxTheme pubsub if available
  try {
    if (window.FoxTheme?.pubsub?.subscribe && window.FoxTheme?.pubsub?.PUB_SUB_EVENTS?.cartUpdate) {
      window.FoxTheme.pubsub.subscribe(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, (payload) => {
        if (payload?.cart) {
          state.cart = payload.cart;
          computeMemberMode();
        }
      });
    }
  } catch (e) {}

  // Also update after cart updates from anywhere
  document.addEventListener('cart:updated', () => refreshCart());

  // Initial
  refreshCart();
})();